import { render, staticRenderFns } from "./BlockList.vue?vue&type=template&id=3ddc1198&scoped=true"
import script from "./BlockList.vue?vue&type=script&lang=js"
export * from "./BlockList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ddc1198",
  null
  
)

export default component.exports